import storage from '@/utils/storage';

let userInfo = {};

export default {
  setUserInfo(params = {}) {
    userInfo = { ...userInfo, ...params };
    storage.setItem('userStore', userInfo);
  },
  getUserStore() {
    if (userInfo && userInfo.userGuid) {
      return userInfo;
    }
    return storage.getItem('userStore', userInfo) || {};
  },
};
